export const encodeFileName = (
  offeringIssuerName: string,
  moduleName: string,
  extension: string = '.xlsx'
) => {
  return `${offeringIssuerName.replace(/[^a-z0-9]/gi, '_')}_${moduleName}${extension}`;
};
